import { CommonModule } from "@angular/common";
import { LOCALE_ID, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgZorroModule } from "./ngzorro.module";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { NgxPermissionsModule } from "ngx-permissions";
import { DynamicFormModule } from "./components/dynamic-form/dynamic-form.module";
import { TextConfirmComponent } from "./components/text-confirm/text-confirm.component";
import { ArraySortPipe } from "./pipes/sort-array.pipe";
import { TituloPrincipalComponent } from "./components/titulo-principal/titulo-principal.component";
import { TrocarProdutoCardComponent } from "./components/trocar-produto-card/trocar-produto-card.component";
import { NgApexchartsModule } from "ng-apexcharts";
import { UploadPictureWallComponent } from "./components/upload-picture-wall/upload-picture-wall.component";
import { DynamicFormComponent } from "./components/dynamic-form/components/dynamic-form/dynamic-form.component";
import { TableCadastroComponent } from "./components/table-cadastro/table-cadastro.component";
import { UploadComponent } from "./components/upload/upload.component";
import { OrderByPipe } from "./pipes/order.pipe";
import { LoaderComponent } from "./components/loader/loader.component";
import { LoaderInterceptorService } from "./components/loader/loader-interceptor.service";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { BlockCopyPasteCutDirective } from "./directives/block-copy-past-cut.directive";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { UppercaseDirective } from "./directives/uppercase.directive";
import { ModalDetalheComponent } from "./components/upload/components/modal-detalhe/modal-detalhe.component";

@NgModule({
  declarations: [
    LoaderComponent,
    TextConfirmComponent,
    ArraySortPipe,
    BlockCopyPasteCutDirective,
    TituloPrincipalComponent,
    TrocarProdutoCardComponent,
    UploadPictureWallComponent,
    DynamicFormComponent,
    TableCadastroComponent,
    UploadComponent,
    ModalDetalheComponent,
    OrderByPipe,
    UppercaseDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgZorroModule,
    DynamicFormModule,
    NgxPermissionsModule.forChild(),
    NgxMaskDirective,
    NgxMaskPipe,
    NgApexchartsModule,
    AngularEditorModule,
    NgxExtendedPdfViewerModule
  ],
  exports: [
    LoaderComponent,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgZorroModule,
    DynamicFormModule,
    BlockCopyPasteCutDirective,
    TextConfirmComponent,
    ArraySortPipe,
    TituloPrincipalComponent,
    TrocarProdutoCardComponent,
    NgApexchartsModule,
    UploadPictureWallComponent,
    DynamicFormComponent,
    TableCadastroComponent,
    UploadComponent,
    OrderByPipe,
    NgxMaskDirective,
    NgxMaskPipe,
    AngularEditorModule,
    NgxExtendedPdfViewerModule,
    UppercaseDirective
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService, multi: true
    },
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
    provideNgxMask()
  ],
})
export class SharedModule { }
